import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const SESSION_FLAG = "isi_pv_sent";

export function trackPageView() {
  // Only track once per session
  if (sessionStorage.getItem(SESSION_FLAG)) return;
  sessionStorage.setItem(SESSION_FLAG, "1");

  const params = new URLSearchParams(window.location.search);
  const payload = {
    path: window.location.pathname || "/",
    referrer: document.referrer || "",
    utm_source: params.get("utm_source") || "",
    utm_medium: params.get("utm_medium") || "",
    utm_campaign: params.get("utm_campaign") || "",
    screen_width: window.innerWidth || 0,
  };

  axios.post(`${API}/track`, payload).catch(() => {});
}

export function loadGA4(measurementId) {
  if (!measurementId || typeof window === "undefined") return;
  if (window.__ga4_loaded) return;
  window.__ga4_loaded = true;

  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", measurementId);
}
